import React from 'react';

import { mapEventHandler } from 'google-maps-react';
import Geocode from 'react-geocode';

import { parseLatLngFromString, getAddressByCoords, getCoordsByAddress, formatCoord, isValidCoords } from 'utils/maps';

const apiKey = process.env.REACT_APP_GOOGLE_MAP;

type Props = {
  onChangeCoords: (value: string) => void;
  onChangeAddress: (value: string) => void;
};

export function useGoogleMaps({ onChangeCoords, onChangeAddress }: Props) {
  const handleChangeAddress = React.useCallback((value: string) => {
    getCoordsByAddress(value).then((res) => {
      if (!res?.lat || !res?.lng) return '';

      onChangeCoords(`${res.lat}, ${res.lng}`);
    });
  }, []);

  const handleChangeCoords = React.useCallback(async (value: string) => {
    if (isValidCoords(value)) {
      const latLng = parseLatLngFromString(value);
      const address = await getAddressByCoords(latLng);

      onChangeAddress(address);

      return onChangeCoords(value);
    }
  }, []);

  const handleClickMap = React.useCallback<mapEventHandler>((_e, _map, clickEvent) => {
    const lat = formatCoord(clickEvent.latLng.lat());
    const lng = formatCoord(clickEvent.latLng.lng());

    const coords = { string: `${lat}, ${lng}`, parsed: { lat, lng } };

    onChangeCoords(coords.string);
    getAddressByCoords(coords.parsed).then(onChangeAddress);
  }, []);

  React.useEffect(() => {
    Geocode.setApiKey(apiKey as string);
  }, []);

  return {
    handleChangeAddress,
    handleChangeCoords,
    handleClickMap,
  };
}
